
















import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import roundItem from '@/components/project/roundItem.vue';

@Component({
  components: { roundItem }
})
class roundList extends Vue {
  tagGroupList: any[] = [];
  roundListTmp: any[] = [];

  // 是否当做筛选项选中
  // true: 在项目详情页中展示的样式,默认字体为蓝色,不带日期
  // false: 在编辑轮次中展示的样式,默认字体为蓝色,修改后为红色,带日期
  @Prop()
  canSelect;

  // 为roundList的index,用于项目详情页中筛选当前轮次的notes
  @Prop()
  value;

  @Prop()
  roundList;

  @Watch('roundList')
  refresh() {
    this.refreshData();
  }

  mounted() {
    this.refreshData();
  }

  refreshData() {
    // 给轮次添加属性
    // isChange: 修改后轮次,展示为红色文字
    // isSecret: 保密中轮次,轮次为最新轮且为融资期
    // isSelected: 通过传入的value匹配roundList的index
    this.roundListTmp = [];
    this.roundList.forEach((_, index) => {
      this.roundListTmp.push({
        ..._,
        // _.selected = this.canSelect && (index === this.value) ? true : false;
        isChange: _.isChange ? _.isChange : false,
        isSecret: index === this.roundList.length - 1 && _.phase === 1 ? true : false
      });
    });
  }

  clickRound(item, index) {
    console.log(item, index);
    this.$emit('clickStage', item, index);
  }
}
export default roundList;
